import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";
import { PaginatedResponse } from  "@/interfaces/api/PaginatedResponse";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest);

export async function getDraftItems(appId: string): Promise<PaginatedResponse<any>> {
    const res = await http.get(`app/${appId}/content/draft`)
    if(res.data) {
        return Promise.resolve(res.data)
    }

    return Promise.reject(new Error(`Couldn't get draft content data`))
}

export async function getMoreDraftItems({appId, skip, top} : {appId: string, skip: number, top: number}): Promise<PaginatedResponse<any>> {
    const requestUrl = `app/${appId}/content/draft?skip=${skip}&top=${top}` 
    const res = await http.get(requestUrl)
    if(res.data) {
        return Promise.resolve(res.data)
    }
    
    return Promise.reject(new Error(`Couldn't get draft content data`))
}

export async function publishItems(appId: string, payload:{contentIds: number[]}): Promise<any>  {
   const res = await http.post(`app/${appId}/content/publish`, payload);
    if(res.data) {
        return Promise.resolve(res.data)
    }   

    return Promise.reject(new Error(`Couldn't publish items, try again`))
}